module.exports = __webpack_public_path__ + "layout_sprites.37ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/layout_sprites.png
// module id = ./src/_asset/sources/assets/images/layout_sprites.png
// module chunks = main